import { useState } from 'react';
//mport ObservationInput from './ObservationInput';
import CustomSelect from '../../../../../../components/common/SelectField';
import { MenuItem } from '@mui/material';
import { TableInput } from '../../../../../../components/common';
import { countBy } from 'lodash';

interface IProps {
  apiData: any;
}
const TBody = ({ apiData }: IProps) => {
  return (
    <tbody>
      {Object.keys(apiData).map((key: any, index: number) => {
        const spaceIndex = key.indexOf(' ');
        const customerName = key.substring(0,spaceIndex);
        const partName = key.substring(spaceIndex+1);
        const partCountDateWise = apiData[key];
        return (
          <tr>
            <td>{index + 1}</td>
            <td>{customerName}</td>
            <td>{partName}</td>
            {partCountDateWise.map((count: number) => {
              return <td>{count}</td>;
            })}
            <td>
              {partCountDateWise.reduce(
                (sum: number, num: number) => sum + num
              )}
            </td>
          </tr>
        );
      })}
    </tbody>
  );
};

export default TBody;
